<template>
  <div class="page-container">
    <div class="header">
      <div class="title">充值记录</div>
    </div>
    <div class="search-form">
      <el-form inline class="inline-form" label-width="120px">
        <el-form-item label="创建时间" size="small">
          <el-date-picker
            v-model="dateTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="业务充值订单号" size="small">
          <el-input v-model="searchForm.applyId" clearable placeholder="请输入业务充值订单号" />
        </el-form-item>
        <el-form-item label="审核状态" size="small">
          <el-select v-model="searchForm.auditStatus" clearable>
            <el-option v-for="([value, label]) in Object.entries(auditStatusOptions)" :value="value" :label="label" :key="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="入账状态" size="small">
          <el-select v-model="searchForm.transStatus" clearable>
            <el-option v-for="([value, label]) in Object.entries(transStatusOptions)" :value="value" :label="label" :key="value" />
          </el-select>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
          <el-button type="primary" @click="handleFormReset" class="bs-btn2">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="200px" />
        <el-table-column prop="applyId" label="业务充值订单号" align="center" min-width="200px" />
        <el-table-column prop="merchantId" label="商户编号" align="center" min-width="130px" />
        <el-table-column prop="merchantName" label="商户名称" align="center" min-width="200px" />
        <el-table-column prop="payer" label="充值方名称" align="center" min-width="130px" />
        <el-table-column prop="payerBankAccountNo" label="充值方账号" align="center" min-width="200px" />
        <el-table-column prop="payerBank" label="充值方开户行" align="center" min-width="200px" />
        <el-table-column prop="amount" label="充值金额" align="center" min-width="130px">
          <template slot-scope="{row}">{{ row.amount / 100 }}</template>
        </el-table-column>
        <el-table-column prop="transferTime" label="充值时间" align="center" min-width="200px" />
        <el-table-column prop="auditStatus" label="审核状态" align="center" min-width="130px">
          <template slot-scope="{row}">{{ auditStatusOptions[row.auditStatus] || '' }}</template>
        </el-table-column>
        <el-table-column prop="transStatus" label="入账状态" align="center" min-width="130px">
          <template slot-scope="{row}">{{ transStatusOptions[row.transStatus] || '' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="120px">
          <template slot-scope="{row}">
            <el-button v-if="row.showPayButton" type="text" @click="handleViewDetail(row)">发起代付</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"
        />
      </div>
    </div>
    <el-dialog title="详情" center :visible.sync="dialog.visible" width="600px" @close="handleCloseDialog">
      <el-steps :active="dialog.active" align-center finish-status="success" style="margin-bottom: 50px;">
        <el-step title="申请代付"></el-step>
        <el-step title="手机验证码验证"></el-step>
        <el-step title="平台审核出款"></el-step>
      </el-steps>
      <el-form
        v-if="[0, 1].includes(dialog.active)"
        ref="dialogForm"
        class="inline-form"
        :model="dialog.form"
        label-width="150px"
        label-position="right"
        size="small"
        v-loading="dialog.loading"
      >
        <template v-if="dialog.active === 0">
          <el-form-item label="业务充值订单号：">{{ dialog.info.applyId }}</el-form-item>
          <el-form-item label="充值金额：">{{ dialog.info.rechargeAmount / 100 }}</el-form-item>
          <el-form-item label="商户名称：">{{ dialog.info.merchantName }}</el-form-item>
          <el-form-item label="收款方名称：">{{ dialog.info.bankAccountName }}</el-form-item>
          <el-form-item label="收款方账号：">{{ dialog.info.bankAccountNo }}</el-form-item>
          <el-form-item label="收款方开户行：">{{ dialog.info.branchBankName }}</el-form-item>
          <el-form-item label="代付金额：">{{ dialog.info.payAmount / 100 }}</el-form-item>
        </template>
        <template v-else>
          <el-form-item label="预留手机验证：">
            <el-input v-model="dialog.form.mobile" placeholder="请输入" readonly clearable>
              <el-button slot="append" @click="sendCode" :disabled="isSendCode">
                {{ isSendCode ? `${dialog.countDownNumber}S` : '获取验证码' }}
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="dialog.form.verifyCode" placeholder="请输入" clearable v-limit-input-number="{ limitNumber: 0 }" :maxlength="4" />
          </el-form-item>
        </template>
      </el-form>
      <p v-if="dialog.active === 2" style="text-align: center;">代付申请已提交，平台当日审核出款，请等待留意相关到账信息!</p>
      <div slot="footer">
        <el-button class="bs-btn2" @click="handleCloseDialog(true)">{{ { 0: '取消', 1: '上一步', 2: '关闭' }[dialog.active] }}</el-button>
        <el-button
          type="primary"
          class="bs-btn"
          v-if="[0, 1].includes(dialog.active)"
          @click="handleConfirmDialog"
          :loading="dialog.loading">
          {{ dialog.active === 0 ? '下一步' : '提交申请' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  commitCfsAccountInfo, queryCfsAccountInfo, queryRechargeRecordDetail, queryRechargeRecordList, sendVerifyCode,
} from "../../../api/cloud-manage";

export default {
  name: "recharge-record",
  data() {
    return {
      dateTimeRange: null,
      searchForm: {
        applyId: '',
        transStatus: '',
        auditStatus: '',
      },
      transStatusOptions: {
        0: '待入账',
        1: '入账成功',
        2: '入账失败',
      },
      auditStatusOptions: {
        0: '待初审',
        1: '初审驳回',
        2: '待复核',
        3: '复核通过',
        4: '复核驳回',
      },
      table: {
        data: [],
        loading: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      dialog: {
        active: 2,
        countDownNumber: 300,
        visible: false,
        loading: false,
        info: {},
        form: {
          applyId: '',
          mobile: '',
          verifyCode: '',
        },
      },
    };
  },
  computed: {
    isSendCode() {
      return this.dialog.countDownNumber < 300;
    },
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.searchForm = {
        applyId: '',
        transStatus: '',
        auditStatus: '',
      };
      this.dateTimeRange = null;
      this.handleFormSearch();
    },
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    queryTableData() {
      const [startTime, endTime] = this.dateTimeRange || [];
      const { pageNo, pageSize } = this.table;
      const params = {
        startTime,
        endTime,
        ...this.searchForm,
        pageNo,
        pageSize,
      };
      this.table.loading = true;
      queryRechargeRecordList(params).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.table.data = data.list;
          this.table.totalCount = data.totalCount;
        } else {
          this.table.data = [];
          this.table.totalCount = 0;
          this.$message.warning(msg);
        }
      }).finally(() => {
        this.table.loading = false;
      });
    },
    handleViewDetail({ applyId }) {
      queryRechargeRecordDetail({ applyId }).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.dialog.form.applyId = applyId;
          this.dialog.info = { ...data };
          this.dialog.active = 0;
          this.dialog.visible = true;
        } else {
          this.$message.warning(msg);
        }
      });
    },
    sendCode() {
      sendVerifyCode({}).then(({ data: { code, msg } }) => {
        if (code === '0') {
          this.$message.success("短信验证码已发送！");
          this.timer = setInterval(() => {
            if (this.dialog.countDownNumber <= 1) {
              clearInterval(this.timer);
              this.dialog.countDownNumber = 300;
            } else {
              this.dialog.countDownNumber -= 1;
            }
          }, 1000);
        } else {
          this.$message.warning(msg);
        }
      });
    },
    handleCloseDialog(isCancel = false) {
      if (isCancel) {
        if (this.dialog.active !== 1) {
          this.resetDialog();
          this.queryTableData();
        }
      } else {
        this.resetDialog();
      }
      this.dialog.active = 0;
    },
    resetDialog() {
      clearInterval(this.timer);
      this.dialog.countDownNumber = 300;
      this.dialog.visible = false;
      this.dialog.form = {
        applyId: '',
        mobile: '',
        verifyCode: '',
      };
    },
    handleConfirmDialog() {
      this.dialog.loading = true;
      switch (this.dialog.active) {
        case 0:
          this.getPhoneNumber();
          break;
        case 1:
          this.commitInfo();
          break;
        default:
          break;
      }
    },
    getPhoneNumber() {
      const { payer, bankAccountName } = this.dialog.info;
      if (payer !== bankAccountName) {
        this.$message.warning('收款方非商户同名对公账户，无法代付，请联系客户经理咨询！');
        this.dialog.loading = false;
        return;
      }
      queryCfsAccountInfo({}).then(({ data: { code, data: { mobile }, msg } }) => {
        if (code === '0') {
          this.dialog.form.mobile = mobile;
          this.dialog.active++;
        } else {
          this.$message.warning(msg);
        }
      }).finally(() => {
        this.dialog.loading = false;
      });
    },
    commitInfo() {
      const { verifyCode } = this.dialog.form;
      if (verifyCode && verifyCode.length === 4) {
        commitCfsAccountInfo(this.dialog.form).then(({ data: { code, data, msg } }) => {
          if (code === '0') {
            clearInterval(this.timer);
            this.dialog.countDownNumber = 300;
            this.dialog.active++;
            this.$message.success('操作成功');
          } else {
            this.$message.warning(msg);
          }
        }).finally(() => {
          this.dialog.loading = false;
        });
      } else {
        this.$message.warning('请输入正确的验证码');
        this.dialog.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .amount-row {
      font-size: 32px;
      line-height: 32px;

      .amount-span {
        margin-right: 20px;
      }
    }
  }

  .table-container {
    padding: 40px 50px;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>
